import { useMemo } from 'react';

import { useAuthContext } from 'src/auth/hooks';
import { PermissionKeys } from 'src/auth/types';

import { useUserPermissions } from './use-user-permissions';

/**
 * Matches backend activity update rules: UPDATE_SERVICE permission and project owner.
 */
export function useCanUpdateOwnedActivity(projectOwnerId?: number | null): boolean {
  const { user } = useAuthContext();
  const { hasAnyPermission } = useUserPermissions();

  return useMemo(() => {
    const canUpdateAny = hasAnyPermission([
      { permission: PermissionKeys.UPDATE_SERVICE, levels: ['GROUP', 'ALL'] },
    ]);
    const canUpdateOwn = hasAnyPermission([
      {
        permission: PermissionKeys.UPDATE_SERVICE,
        levels: ['ACTIVITIES_UNDER_MY_PROJECTS'],
      },
    ]);
    const isOwnedActivity =
      projectOwnerId != null &&
      user?.id != null &&
      Number(projectOwnerId) === Number(user.id);

    return (canUpdateAny || canUpdateOwn) && isOwnedActivity;
  }, [hasAnyPermission, projectOwnerId, user?.id]);
}
